import createAxiosInstance from './axiosConfig';
import { ArquivoDTO } from '../shared/dto/arquivoDTO';
import { BaixaParcelaDTO } from '../shared/dto/baixaParcelaDTO';
import { EstornoParcelaDTO } from '../shared/dto/estornoParcelaDTO';
import { ProrrogacaoVencimentoParcelaDTO } from '../shared/dto/prorrogacaoVencimentoParcelaDTO';
import { BaixaParcelaFinanceiraPorEmpregadorDTO } from '../shared/dto/baixaParcelaFinanceiraPorEmpregadorDTO';
import { ObservacaoParcelaDTO } from '../shared/dto/observacaoParcelaDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/operacaoParcelaController');

export default class OperacaoParcelaService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async processarArquivoLote(tipoArquivoProcessamento: string, numeroCessao: string, arquivoDTO: ArquivoDTO) {
    return await this.axios.post(`/processarArquivoLote?tipoArquivo=${tipoArquivoProcessamento}&idCessao=${numeroCessao}`, arquivoDTO);
  };

  async reprocessarArquivoLote(tipoArquivoProcessamento: string, idArquivo: string) {
    return await this.axios.post(`/reprocessarArquivoLote?idArquivo=${idArquivo}&tipoArquivo=${tipoArquivoProcessamento}`, {});
  };

  async listarParcelasPorContrato(contrato: string) {
    return await this.axios.get(`/listarParcelasPorContrato?contrato=${contrato}`);
  };

  async listarParcelasParaBaixa(contrato: string, dto: BaixaParcelaDTO) {
    return await this.axios.post(`/listarParcelasParaBaixa?contrato=${contrato}`, dto);
  };

  async baixarParcelas(contrato: string, dto: BaixaParcelaDTO) {
    return await this.axios.post(`/baixarParcelas?contrato=${contrato}`, dto);
  };

  async listarParcelasParaBaixaFinanceiras(contrato: string, dto: BaixaParcelaDTO) {
    return await this.axios.post(`/listarParcelasParaBaixaFinanceira?contrato=${contrato}`, dto);
  };

  async listarParcelasParaBaixaFinanceirasEmpregador(dto: BaixaParcelaFinanceiraPorEmpregadorDTO) {
    return await this.axios.post(`/listarParcelasParaBaixaFinanceiraPorEmpregador`, dto);
  };

  async baixarParcelasFinanceiras(contrato: string, dto: BaixaParcelaDTO) {
    return await this.axios.post(`/baixarParcelasFinanceiras?contrato=${contrato}`, dto);
  };
  
  async listarParcelasBaixadasPorContrato(contrato: string) {
    return await this.axios.get(`/listarParcelasBaixadasPorContrato?contrato=${contrato}`);
  };
  
  async cancelarMovimentacao(motivo: string, dto: EstornoParcelaDTO[]) {
    return await this.axios.post(`/cancelarMovimentacao?motivoCancelamento=${motivo}`, dto);
  };

  async estornarParcelas(dto: EstornoParcelaDTO[]) {
    return await this.axios.post(`/estornarParcelas`, dto);
  };

  async listarParcelasParaProrrogacao(contrato: string, comecarDaParcela: number, dtVencimentoProrrogacao: Date) {
    return await this.axios.get(`/listarParcelasParaProrrogacao?contrato=${contrato}&comecoParcela=${comecarDaParcela}&dtProrrogacao=${dtVencimentoProrrogacao.toISOString().split(".")[0]}`);
  };

  async prorrogarParcelas(dtMovimento: Date, dto: ProrrogacaoVencimentoParcelaDTO[]) {
    return await this.axios.post(`/prorrogarParcelas?dtMovimentacao=${dtMovimento.toISOString().split(".")[0]}`, dto);
  };

  async getOperacaoParcelaTipoMovimentacaoEnum() {
    return await this.axios.get(`/getOperacaoParcelaTipoMovimentacaoEnum`);
  };

  async listarOperacoesRefinPorCpfMatriculaEmpregador(cpf: string, matricula: string, empregador: string) {
    return await this.axios.get(`/listarOperacoesRefinPorCpfMatriculaEmpregador?cpf=${cpf}&matricula=${matricula}&empregador=${empregador}`);
  };

  async repactuarParcela(request: { numeroContrato: string, numeroParcelaAlvo: number }) {
    return await this.axios.post(`/repactuarParcela`, request);
  };

  async repactuarParcelasPorFaixa(request: { numeroContrato: string, faixaInicio: number, faixaFim: number }) {
    return await this.axios.post(`/repactuarParcelasPorFaixa`, request);
  }

async buscarObservacao(numeroContrato: string, numeroParcela: number) {
    return await this.axios.get(`/buscarObservacao?numeroContrato=${numeroContrato}&numeroParcela=${numeroParcela}`);
  };

  async salvarObservacao(dto: ObservacaoParcelaDTO) {
    return await this.axios.post(`/salvarObservacao`, dto);
  };


}
